module.exports = __webpack_public_path__ + "static/media/edwinVindas.770e1d07.jpg";